import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ApiDropdown from "../../Components/DropDown/Apidropdown";
import Input from "../../Components/input/input";
import config from "../../config";
import "../../Style/IncidentAdd.css";

import { useFetchFullName } from "../Incidents/Hooks/useFetchFullName";
import { AdminRequest, initialAdminRequest } from "./AdminRequest";

import TextArea from "../../Components/TextArea/TextArea";

import { authFetch } from "../../utils/Security/authFetch";
import Button from "../../Components/button/button";

type Person = {
  id: number;
  name: string;
};
const AdminRequestAdd: React.FC = () => {
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const UserId = localStorage.getItem("userid");
  const [adminRequest, setAdminRequest] =
    useState<AdminRequest>(initialAdminRequest);

  const [emails, setEmails] = useState<[]>();
  const [managerId, setManagerId] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [type, setType] = useState<
    string | number | (string | number)[] | null
  >(null);
  const navigate = useNavigate();

  useFetchFullName((fullName: string) => {
    setAdminRequest((prev) => ({ ...prev, user: fullName }));
  });
  type ValType = string | number | (string | number)[] | null | undefined;

  const handleChange = (field: keyof AdminRequest, value: any) => {
    setAdminRequest((prev) => {
      const updated = { ...prev, [field]: value };

      return updated;
    });
  };
  useEffect(() => {
    if (!UserId) return;

    const fetchManager = async () => {
      try {
        const response = await authFetch(
          `${config.apiBaseUrl}/api/user-manager/manager/${UserId}`
        );

        const data = await response.json();
        console.log("managersssssssssss", data);

        const managerId = data[0];
        const managerName = data[1];

        const emailRes = await authFetch(
          `${config.apiBaseUrl}/api/users/email-by-id?id=${managerId}`
        );
        const emailList = await emailRes.json();
        setEmails(emailList);

        const managerEmail = emailList[0] || "";
        setManagerId(managerId);
        setAdminRequest((prev) => ({
          ...prev,
          managerId,
          managerName,
          managerEmail,
        }));
      } catch (err) {
        console.error("Error fetching manager or email:", err);
      }
    };

    fetchManager();
  }, [UserId]);

  const validateForm = (): boolean => {
    if (!adminRequest) {
      alert("AdminRequest data is not available.");
      return false;
    }

    return true;
  };
  const handleSubmit = async () => {
    if (!validateForm()) return;

    // Prepare payload with foruserid including both user and manager
    const payload = {
      ...adminRequest,
      foruserid: [Number(UserId), Number(managerId)],
    };

    try {
      const targetManagerId =
        Number(UserId) === Number(managerId) ? 509 : managerId;

      const response = await authFetch(
        `${config.apiBaseUrl}/api/adminRequests?managerId=${targetManagerId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit adminRequest");
      }

      const savedAdminRequest = await response.json();

      setAdminRequest({
        ...initialAdminRequest,
        ticketId: savedAdminRequest.ticketId,
      });

      const recipients =
        Number(UserId) === Number(managerId)
          ? ["jacksondoumith006@gmail.com"]
          : emails || [];

      if (recipients.length > 0) {
        await authFetch(`${config.apiBaseUrl}/api/email/send`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            to: recipients,
            subject: `ADM ID ${savedAdminRequest.ticketId} - Opened`,
            body: `
      <div style="font-family: Arial, sans-serif; font-size: 14px;">
        <p>Hello,</p>

        <p>A new Admin Request with ID 
           <strong>${savedAdminRequest.ticketId}</strong> has been created.</p>
 <p>Created By:<br> ${adminRequest.createdBy}</p>
  <p>Ticket Creation Date/Time:<br> ${adminRequest.ticketCreationDatetime}</p>
   <p>Ticket Closure Date/Time:<br> ${adminRequest.ticketClosureDatetime}</p>
    <p>Type:<br> ${adminRequest.type}</p>
     <p>SubType:<br> ${adminRequest.subType}</p>
      <p>Description:<br> ${adminRequest.description}</p>
        <p>Reason/Purpose/:<br> ${adminRequest.resonPurpose}</p>
                <p>Closure Code/:<br> ${adminRequest.closureCode}</p>

 <br><br>
                      Regards, <br><br>

                               <p>
              <a href=https://bdm.bcomsat.com/" target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
               👉 View AdminRequest Details
            </a>
        <br>

        <a href="${config.apiBaseUrl}/api/adminRequests/${savedAdminRequest.ticketId}/manageraccept"
           style="background:#28a745;color:white;padding:10px 18px;text-decoration:none;border-radius:6px;display:inline-block;margin-right:10px;"
           target="_blank">
           ✅ Accept
        </a>

        <a href="${config.apiBaseUrl}/api/adminRequests/${savedAdminRequest.ticketId}/managerreject"
           style="background:#dc3545;color:white;padding:10px 18px;text-decoration:none;border-radius:6px;display:inline-block;"
           target="_blank">
           ❌ Reject
        </a>

        <br><br>
        <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
  <tr>
          <td style="vertical-align: top; padding-right: 12px;">
            <h1 style="
           margin: 0;
            font-family: 'Poppins', 'Segoe UI Black', 'Arial Black', sans-serif;
          font-size: 36px;
 font-style: italic ;
            font-weight: 900;
              color: #30087B;
          letter-spacing: 0.5px;
             text-transform: uppercase;
            ">
SES
           </h1>
        </td>

        <td>
         <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
           font-size: 13px;
           ">
           <strong>Managed Services Operations</strong><br>
           Value-Added Service<br>
             Tel. & WhatsApp msg: +41 225521085<br>
             Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
           </div>
        </td>
      </tr>
     </table>
      </div>
    `,
          }),
        });
      }

      navigate("/admin");
    } catch (error) {
      alert(`Submission error: ${(error as Error).message}`);
      console.error(`Submission error: ${(error as Error).message}`);
    }
  };

  // const handleSubmit = async () => {
  //   if (!validateForm()) return;

  //   try {
  //     const response = await authFetch(
  //       `${config.apiBaseUrl}/api/adminRequests`,
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(adminRequest),
  //       }
  //     );
  //     const savedAdminRequest = await response.json();
  //     adminRequest.ticketId = savedAdminRequest.ticketId;

  //     try {
  //       const jackson = ["jacksondoumith006@gmail.com"];

  //       //         await authFetch(`${config.apiBaseUrl}/api/email/send`, {
  //       //           method: "POST",
  //       //           headers: {
  //       //             "Content-Type": "application/json",
  //       //           },

  //       //           body: JSON.stringify({
  //       //             to: jackson,
  //       //             //  emails
  //       //             subject: `AdminRequest ID ${adminRequest.ticketId} |  | - added to You`,
  //       //             body: `
  //       //                     Hello <br><br>
  //       //                     A adminRequest with ID ${adminRequest.ticketId} has been opened with the following comments: <br><br>
  //       //                       Customer:  <br><br>

  //       //                       Description: ${adminRequest.description} <br><br>
  //       //                       Closure code: ${adminRequest.closureCode} <br><br>
  //       //                       <br><br>
  //       //                       Regards, <br><br>

  //       //                                <p>
  //       //               <a href=https://bdm.bcomsat.com/" target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
  //       //                 👉 View AdminRequest Details
  //       //               </a>
  //       //             </p>

  //       //        <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
  //       //       <tr>
  //       //         <td style="vertical-align: top; padding-right: 12px;">
  //       //           <h1 style="
  //       //             margin: 0;
  //       //             font-family: 'Poppins', 'Segoe UI Black', 'Arial Black', sans-serif;
  //       //             font-size: 36px;
  //       // font-style: italic ;
  //       //             font-weight: 900;
  //       //             color: #30087B;
  //       //             letter-spacing: 0.5px;
  //       //             text-transform: uppercase;
  //       //           ">
  //       //             SES
  //       //           </h1>
  //       //         </td>

  //       //         <td>
  //       //           <div style="
  //       //             padding: 12px;
  //       //             border-left: 4px solid #2a1364;
  //       //             background-color: #f9f9f9;
  //       //             color: #2a1364;
  //       //             font-size: 13px;
  //       //           ">
  //       //             <strong>Managed Services Operations</strong><br>
  //       //             Value-Added Service<br>
  //       //             Tel. & WhatsApp msg: +41 225521085<br>
  //       //             Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
  //       //           </div>
  //       //         </td>
  //       //       </tr>
  //       //     </table>
  //       //               </div>

  //       //                     `,
  //       //           }),
  //       //         });
  //     } catch (emailErr) {
  //       console.error("Failed to send email notification:", emailErr);
  //     }

  //     //   handleChange("foruserid", userid);
  //     if (!response.ok) throw new Error("Failed to submit adminRequest");

  //     setAdminRequest({
  //       ...initialAdminRequest,
  //       ticketId: adminRequest.ticketId,
  //     });
  //     navigate("/adminRequest");
  //   } catch (error) {
  //     alert(`Submission error: ${(error as Error).message}`);
  //     console.error(`Submission error: ${(error as Error).message}`);
  //   }
  // };
  const normalize = (
    value: string | number | (string | number)[] | null
  ): string => {
    if (value === null) return "";
    if (Array.isArray(value)) return String(value[0]); // or value.join(",")
    return String(value);
  };
  return (
    <div className="adminRequest-form">
      <section className="form-section">
        <h3>Request Information</h3>

        <div className="grid2">
          <Input
            readOnly
            type="text"
            label="Ticket ID"
            value={adminRequest.ticketId || ""}
            onChange={() => {}}
          />

          <ApiDropdown
            api="Urgencys"
            required
            labelKey="name"
            valueKey="name"
            label="Priority"
            onChange={(val) => handleChange("priority", val)}
          />
          <ApiDropdown
            api="types"
            required
            labelKey="name"
            valueKey="name"
            label="Type"
            onChange={(val) => {
              setType(val);
              handleChange("type", val);
            }}
          />
          <ApiDropdown
            api={`subtypes?type=${encodeURIComponent(normalize(type))}`}
            labelKey="subtype"
            valueKey="subtype"
            label="Type"
            onChange={(val) => handleChange("subType", val)}
          />
          <TextArea
            label="Description"
            required={true}
            value={adminRequest.description}
            style={{
              minHeight: "100px",
              minWidth: "90%",
              backgroundColor: "white",
            }}
            onChange={(val) => handleChange("description", val)}
          />
        </div>
      </section>

      <div className="submit-section">
        <Button onClick={handleSubmit}>Submit AdminRequest</Button>
      </div>
    </div>
  );
};

export default AdminRequestAdd;
